/* eslint-disable */
// @ts-nocheck
/*
* This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as fm from "../../../../fetch.pb";
var StateSerialization = /** @class */ (function () {
    function StateSerialization() {
    }
    StateSerialization.GetSessionState = function (req, initReq) {
        return fm.fetchReq("/v1/".concat(req["name"], "/state?").concat(fm.renderURLSearchParams(req, ["name"])), __assign(__assign({}, initReq), { method: "GET" }));
    };
    return StateSerialization;
}());
export { StateSerialization };
